import React, { useEffect, useState } from "react";
import instance from "../../api/api";
import InputCreate from "../../features/InputCreate";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Button from "../../features/Button";
import { Header, LoadingSpinner } from "../../shared/compoments";
import { MultiSelect } from "primereact/multiselect";

function CreatePersonnel() {
  const styleBtn = {
    padding: ".6em 1.2em",
    borderRadius: "8px",
    fontWeight: "bold",
    cursor: "pointer",
    color: "white",
    backgroundColor: "#ffb12f",
    marginTop: "1em",
    border: "none",
    transition: "0.3s",
  };

  const MySwal = withReactContent(Swal);

  const [data, setData] = useState({
    nom: "",
    prenom: "",
    role_id: "",
    email: "",
    phone: "",
    permissions: [],
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [allProfil, setAllProfil] = useState([]);
  const [isLoadingSpinner, setIsLoadingSpinner] = useState(true);
  const [allPermission, setAllPermission] = useState([]);
  const [selectedPermission, setSelectedPermission] = useState(null);

  const savePersonnel = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const formData = new FormData();
      for (const element in data.permissions) {
        formData.append("permissions[]", data.permissions[element]);
      }
      formData.append("nom", data.nom);
      formData.append("prenom", data.prenom);
      formData.append("role_id", data.role_id);
      formData.append("phone", data.phone);
      formData.append("email", data.email);
      formData.append("password", data.password);

      const response = await instance.post("users", formData);

      if (response.data.status === false) {
        let msgError = [];
        for (const property in response.data.message) {
          msgError = [...msgError, response.data.message[property]];
        }
        MySwal.fire({
          title: msgError,
          icon: "info",
          showConfirmButton: true,
        });
      } else {
        setData({
          nom: "",
          prenom: "",
          role_id: "",
          email: "",
          phone: "",
          permissions: [],
          password: "",
        });
        MySwal.fire({
          title: "Enregistrement réussi 🎉",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      let msgError = [];
      for (const property in error.response.data.message) {
        msgError = [...msgError, error.response.data.message[property]];
      }
      MySwal.fire({
        title: msgError,
        icon: "info",
        showConfirmButton: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const listerRolesPermission = async () => {
      const response = await instance.get("roles");
      const responseService = await instance.get("permissions");
      setAllProfil(response?.data.data);
      setAllPermission(responseService?.data.data);
      setIsLoadingSpinner(false);
    };
    listerRolesPermission();
  }, []);

  if (isLoadingSpinner) return <LoadingSpinner />;

  return (
    <>
      <Header libelle={"Enregistrer une personne"} isReturn />
      <div className="container py-4">
        <form
          onSubmit={savePersonnel}
          className="create-user bg-white shadow-sm p-4 rounded">
          <div className="row g-4">
            <div className="col-lg-4 col-md-6">
              <label htmlFor="profil" className="form-label fw-semibold">
                Profil
              </label>
              <select
                name="profil"
                id="all_categorie"
                onChange={(e) => setData({ ...data, role_id: e.target.value })}
                className="form-select"
                defaultValue="">
                <option value="" disabled>
                  Sélectionner un profil
                </option>
                {allProfil?.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.libelle}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-lg-8 col-md-6">
              <label htmlFor="permissions" className="form-label fw-semibold">
                Permissions
              </label>
              <MultiSelect
                value={selectedPermission}
                options={allPermission}
                onChange={(e) => {
                  const tableau = e.value.map((element) => element.id);
                  setData({ ...data, permissions: tableau });
                  setSelectedPermission(e.value);
                }}
                optionLabel="libelle"
                placeholder="Sélectionner les permissions"
                className="w-100"
                display="chip"
              />
            </div>

            <div className="col-lg-4 col-md-6">
              <InputCreate
                label="Nom"
                typeInput="text"
                nameInput="name"
                active
                getValue={(e) => setData({ ...data, nom: e.target.value })}
                dataValue={data.nom}
              />
            </div>

            <div className="col-lg-4 col-md-6">
              <InputCreate
                label="Prénoms"
                typeInput="text"
                nameInput="text"
                active
                getValue={(e) => setData({ ...data, prenom: e.target.value })}
                dataValue={data.prenom}
              />
            </div>

            <div className="col-lg-4 col-md-6">
              <InputCreate
                label="Email"
                typeInput="email"
                nameInput="email"
                active
                getValue={(e) => setData({ ...data, email: e.target.value })}
                dataValue={data.email}
              />
            </div>

            <div className="col-lg-4 col-md-6">
              <InputCreate
                label="Téléphone"
                typeInput="phone"
                nameInput="phone"
                active
                getValue={(e) => setData({ ...data, phone: e.target.value })}
                dataValue={data.phone}
              />
            </div>

            <div className="col-lg-4 col-md-6">
              <InputCreate
                label="Mot de passe"
                typeInput="password"
                nameInput="password"
                active
                getValue={(e) => setData({ ...data, password: e.target.value })}
                dataValue={data.password}
              />
            </div>

            <div className="col-12 text-center mt-3">
              <Button
                titre="Enregistrer"
                styleBtn={styleBtn}
                isLoading={isLoading}
              />
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default CreatePersonnel;
